const SiteConstant = {
    company_name: "Benefit Specialists",
    domain: "LocalHost",
    who_operates: "Insurance Agents"
}

export default SiteConstant;